import React from "react";
import { Paper, IconButton, Box, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MapRainforestMarker } from "types/map";
import MapMarkerRainforestInfo from "./MapMarkerRainforestInfo";

type Props = {
  open: boolean;
  onClose: () => void;
  marker: MapRainforestMarker;
  squareFootage?: number;
};

const MapMarkerRainforestPanel = ({ open, onClose, marker, squareFootage }: Props) => {
  return (
    <Slide direction="left" in={open} mountOnEnter unmountOnExit>
      <Paper
        elevation={4}
        sx={{
          position: "absolute",
          top: 20,
          right: 20,
          width: { xs: 'calc(100% - 40px)', sm: 450 },
          maxHeight: 'calc(100% - 40px)',
          overflowY: 'auto',
          borderRadius: 1,
          zIndex: 1200,
          pointerEvents: 'auto'
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ p: 1 }}>
          <MapMarkerRainforestInfo marker={marker} squareFootage={squareFootage} />
        </Box>
      </Paper>
    </Slide>
  );
};

export default MapMarkerRainforestPanel;
